import React, { useEffect, useState } from 'react';
import { api_url } from '../../Constants/web_services';
import moment from 'moment/moment';
import '../../Assets/css/custom.css'

const CompanyOrderReviews = ({ company }) => {
    const [orderReviews, setOrderReviews] = useState([]);
    useEffect(() => {
        const getOrderReviews = async (companyId) => {
            const apiUrl = api_url + `/api/company-order-reviews/${companyId}`;
            try {
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
                const reviewsWithShowFull = data?.review?.map(review => ({ ...review, showFull: false })) || [];
                setOrderReviews(reviewsWithShowFull);
            } catch (error) {
                console.error("Error fetching order reviews:", error);
            }
        };

        if (company?.id) {
            getOrderReviews(company.id);
        }
    }, [company?.id]);



    const toggleReadMore = (index) => {
        setOrderReviews(prevReviews =>
            prevReviews.map((review, i) =>
                i === index ? { ...review, showFull: !review.showFull } : review
            )
        );
    };

    const renderStars = (rating) => {
        const totalStars = 5;
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;

        return (
            <div className="sf-ow-pro-rating">
                {[...Array(totalStars)].map((_, i) => {
                    if (i < fullStars) {
                        return <span key={i} className="fa fa-star" />;
                    } else if (i === fullStars && hasHalfStar) {
                        return <span key={i} className="fa fa-star-half-o" />;
                    } else {
                        return <span key={i} className="fa fa-star text-022279 font-size-12" />;
                    }
                })}
            </div>
        );
    };

    return (

        <div
            id="aon-provider-review">

            <div className="row d-flex flex-wrap a-b-none">
                <h3 className="sf-provi-title s-18 fw-800 text-drk-primary">Customer Reviews</h3>
                <div className="sf-divider-line" />
                {orderReviews.length > 0 ? (
                    orderReviews.map((review, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                            {review?.order_status === "Completed" ? (<div className="sf-review-box sf-shadow-box">
                                <div className="sf-review-head clearfix">
                                    <div className="sf-review-pic">
                                        <img src={api_url + '/' + review?.user?.image} alt="" />
                                    </div>
                                    <div className="sf-review-info">
                                        <h5 className="sf-review-name">{review?.user?.username}</h5>
                                        <div className="sf-review-feedback mb-1">{review?.review}</div>
                                    </div>
                                    <div className="row justify-content-between">

                                        <div className="sf-review-date">{moment(review?.updated_at).format('LL')} </div>
                                        <div className="sf-review-date"> {moment(review?.updated_at).format('h:mm a')} </div>
                                    </div>
                                </div>
                                <div className="sf-review-body">
                                    <ul className="sf-review-rating d-flex flex-wrap pl-0 mb-1">
                                        <li className='text-center'>
                                            <div className="sf-customer-rating-names">Quality</div>
                                            <div className="sf-customer-rating-star">
                                                <div className="sf-ow-pro-rating">
                                                    {renderStars(review?.quality)}
                                                    <span className='text-center text-022279'>
                                                        {review?.quality}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                        {/* <li className='text-center'>
                                        <div className="sf-customer-rating-names">Cost</div>
                                        <div className="sf-customer-rating-star">
                                            <div className="sf-ow-pro-rating">
                                                {renderStars(review?.order_rating)}
                                                <span className='text-center text-022279'>
                                                    {review?.order_rating}
                                                </span>
                                            </div>
                                        </div>
                                    </li> */}
                                        <li className='text-center'>
                                            <div className="sf-customer-rating-names">Timeline</div>
                                            <div className="sf-customer-rating-star">
                                                <div className="sf-ow-pro-rating">
                                                    {renderStars(review?.timeline)}
                                                    <span className='text-center text-022279'>
                                                        {review?.timeline}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                                <div className="sf-review-body ">
                                    <ul className="sf-review-rating row justify-content-center pl-0 ">

                                        <li className='text-center'>
                                            <div className="sf-customer-rating-names">Response Time</div>
                                            <div className="sf-customer-rating-star">
                                                <div className="sf-ow-pro-rating">
                                                    {renderStars(review?.response_time)}
                                                    <span className='text-center text-022279'>
                                                        {review?.response_time}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>


                                    </ul>
                                </div>
                                <div className="sf-review-footer sf-shadow-box">
                                    <span className="sf-review-write">
                                        {review?.desc_review && review?.desc_review?.length > 25 ? (
                                            <>
                                                {review.showFull ? review.desc_review : review.desc_review.substring(0, 25) + '...'}
                                                <span className="sf-review-red-less" onClick={() => toggleReadMore(index)}>
                                                    {review.showFull ? ' Show Less' : ' Read More'}
                                                </span>
                                            </>
                                        ) : (
                                            review.desc_review
                                        )}
                                    </span>
                                </div>
                            </div>) : (<></>)}

                        </div>

                    ))
                ) : (
                    <div className="row justify-content-center">

                        <div className="col-lg-4 col-md-4">
                            <div className="loader">
                                <div className="loader-text">No Reviews available...</div>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    );
}

export default CompanyOrderReviews;
